module.exports = __webpack_public_path__ + "static/media/bg-step-done-1.23eb38fd.png";